<template lang="pug">
div
  SubHeader(apiname='feature',headname='機能・特徴')
  .card
    .container-fluid
      h3.box-title 機能・特徴一覧
      WorkList(apiname='feature',editPath='edit')
      router-link(to='edit')
        el-button.col-md-12(type='primary', icon='el-icon-edit') 新規登録

</template>

<script>
import SubHeader from '@/views/components/swan/common/SubHeader'
import WorkList from '@/views/components/swan/common/List'
export default {
  name: 'Top',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  components: {
    SubHeader,
    WorkList
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/components/swan/feature/list.vue